import React from 'react'
import clsx from 'clsx'

import OverflowText from '../../../atoms/OverflowText'

import { useBreakpoint } from '../../../../providers/BreakpointProvider'
import useBaseStyles from '../styles'

const Verified = ({ user, meta, date }) => {
  const { isSmall } = useBreakpoint()

  const baseClasses = useBaseStyles()

  if (isSmall) {
    return (
      <div>
        <OverflowText>
          <div
            className={clsx(baseClasses.message, baseClasses.forceFlex)}
            style={{ flex: 1, minWidth: '0' }}
          >
            Conversation
            <div className={baseClasses.bold}>
              {meta?.verified ? 'verified' : 'unverified'}
            </div>
            {user && (
              <>
                by
                <div className={clsx(baseClasses.bold)}>{user.name}</div>
              </>
            )}
          </div>
        </OverflowText>
        <div className={clsx(baseClasses.message)}>{date}</div>
      </div>
    )
  }

  return (
    <OverflowText>
      <div
        className={clsx(baseClasses.message, baseClasses.forceFlex)}
        style={{ flex: 1, minWidth: '0' }}
      >
        Conversation
        <div className={baseClasses.bold}>
          {meta?.verified ? 'verified' : 'unverified'}
        </div>
        {user && (
          <>
            by
            <div className={clsx(baseClasses.bold)}>{user.name}</div>
          </>
        )}
        <div className={clsx(baseClasses.date)}>{date}</div>
      </div>
    </OverflowText>
  )
}

export default Verified
